import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { DepartmentPermissionModel } from "@/model/user/ApplicationPermissionModel";

export function DefineDepartmentPermissionAbility(departmentPermission: DepartmentPermissionModel, can: any) {
  const { information, report } = departmentPermission ?? {};

  information?.view && can(AbilityAction.Access, AbilitySubject.ViewDepartment);
  information?.create && can(AbilityAction.Create, AbilitySubject.CreateDepartment);
  information?.edit && can(AbilityAction.Update, AbilitySubject.EditDepartment);
  information?.delete && can(AbilityAction.Update, AbilitySubject.DeleteDepartment);

  report?.print && can(AbilityAction.Create, AbilitySubject.ExportDepartment);
}
